import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "color", "elevation", "noBorder", "noPadding", "noPaddingLeft", "noPaddingRight", "noPaddingBottom", "noPaddingTop", "narrow", "narrowLeft", "narrowRight", "narrowTop", "narrowBottom", "spacious"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function O2Pane(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      elevation = props.elevation,
      noBorder = props.noBorder,
      noPadding = props.noPadding,
      noPaddingLeft = props.noPaddingLeft,
      noPaddingRight = props.noPaddingRight,
      noPaddingBottom = props.noPaddingBottom,
      noPaddingTop = props.noPaddingTop,
      narrow = props.narrow,
      narrowLeft = props.narrowLeft,
      narrowRight = props.narrowRight,
      narrowTop = props.narrowTop,
      narrowBottom = props.narrowBottom,
      spacious = props.spacious,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var classes = classNames(className, 'o2-pane', color ? "o2-pane--" + color : false, {
    'o2-pane--elevation-1': elevation,
    'o2-pane--no-border': noBorder,
    'o2-pane--no-padding': noPadding,
    'o2-pane--no-padding-left': noPaddingLeft,
    'o2-pane--no-padding-right': noPaddingRight,
    'o2-pane--no-padding-top': noPaddingTop,
    'o2-pane--no-padding-bottom': noPaddingBottom,
    'o2-pane--narrow': narrow,
    'o2-pane--narrow-left': narrowLeft,
    'o2-pane--narrow-right': narrowRight,
    'o2-pane--narrow-top': narrowTop,
    'o2-pane--narrow-bottom': narrowBottom,
    'o2-pane--spacious': spacious
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
    className: classes
  }), children);
}

O2Pane.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  elevation: PropTypes.bool,
  noBorder: PropTypes.bool,
  noPadding: PropTypes.bool,
  noPaddingLeft: PropTypes.bool,
  noPaddingRight: PropTypes.bool,
  noPaddingBottom: PropTypes.bool,
  noPaddingTop: PropTypes.bool,
  narrow: PropTypes.bool,
  narrowLeft: PropTypes.bool,
  narrowRight: PropTypes.bool,
  narrowTop: PropTypes.bool,
  narrowBottom: PropTypes.bool,
  spacious: PropTypes.bool,
  color: PropTypes.oneOf(["white", "success", "warning", "danger", "brand", "grey", "internal", "price"]),
  noWidth: PropTypes.bool
};
export default O2Pane;